import { render, staticRenderFns } from "./EducationalGroups.vue?vue&type=template&id=8bf4f9ec&"
import script from "./EducationalGroups.vue?vue&type=script&lang=js&"
export * from "./EducationalGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports